// extracted by mini-css-extract-plugin
export default {"permissionCard":"LocationPermission_permissionCard__N5qsP","allowButton":"LocationPermission_allowButton__UWomC","errorMessage":"LocationPermission_errorMessage__VRc4Z"};